import { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

export const DEFAULT_REG_PRICES = { amateur: "89.00", seminar_adult: "169.00", seminar_kids: "119.00" };

// Live package prices (admin-editable). Falls back to defaults if the API is unreachable.
export const useRegPrices = () => {
  const [prices, setPrices] = useState(DEFAULT_REG_PRICES);
  useEffect(() => {
    fetch(`${API}/api/registrations/prices`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (d) setPrices({ ...DEFAULT_REG_PRICES, ...d }); })
      .catch(() => {});
  }, []);
  return prices;
};
